import { Transaction } from '../../types/checkout';

export const hasCapturableState = (transaction: Transaction): boolean => {
    return ['AUTHORIZED', 'PARTIALLY_CAPTURED'].includes(transaction.status || '');
};
